// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3W9id","list":"styles_list__2D_mZ"};